import { DatePicker, Form, FormInstance, Input, Select } from "antd";

import Typography from "../../Typography/Typography";
import DocumentModalFileUploader from "./DocumentModalFileUploader";
import { usePermissions } from "@/common/contexts/Permissions.context";
import DocumentCompanyByName from "./DocumentCompanyByName";
import { DocumentFormFields } from "@/common/types/forms/DocumentFormFields.type";

export default function DocumentAgreementStep({
  form,
  selectedCompanyType,
}: {
  form: FormInstance<DocumentFormFields>;
  selectedCompanyType: string;
}) {
  const { company } = usePermissions();

  return (
    <>
      <Typography
        mb={4}
        type="p"
        fontFamily="font-kanit"
        fontWeight="font-light"
        fontSize={16}
      >
        Document Subtype
        <Typography
          type="span"
          fontFamily="font-kanit"
          fontWeight="font-light"
          textColor="error"
        >
          *
        </Typography>
      </Typography>
      <Form.Item
        name="subType"
        rules={[{ required: true, message: "Please select a subtype" }]}
      >
        <Select
          placeholder="Choose subtype"
          className="min-w-[475px] w-full bg-gray-border hover:bg-primaryDim h-10 rounded-lg"
        >
          <Select.Option value="NDA">NDA</Select.Option>
          <Select.Option value="MSA">MSA</Select.Option>
          <Select.Option value="SLA">SLA</Select.Option>
          <Select.Option value="T_AND_C">T&C</Select.Option>
          <Select.Option value="OTHER">Other</Select.Option>
        </Select>
      </Form.Item>
      {company.companyType === "airx" && selectedCompanyType !== "airx" && (
        <DocumentCompanyByName
          selectedCompanyType={selectedCompanyType}
          form={form}
        />
      )}
      <Typography
        mb={4}
        type="p"
        fontFamily="font-kanit"
        fontWeight="font-light"
        fontSize={16}
      >
        Description
      </Typography>
      <Form.Item name="description">
        <Input
          placeholder="Type any description"
          className="min-w-[245px] bg-gray-border border-none hover:bg-primaryDim h-10 rounded-lg"
        />
      </Form.Item>
      <div className="flex flex-col gap-5">
        <div className="flex justify-between">
          <div>
            <Typography
              mb={4}
              type="p"
              fontFamily="font-kanit"
              fontWeight="font-light"
              fontSize={16}
            >
              Signed Date
              <Typography
                type="span"
                fontFamily="font-kanit"
                fontWeight="font-light"
                textColor="error"
              >
                *
              </Typography>
            </Typography>
            <Form.Item
              name="signedAt"
              rules={[
                { required: true, message: "Please select a signed date" },
              ]}
            >
              <DatePicker
                className="min-w-[230px] h-[48px] rounded-lg bg-gray-border hover:bg-primaryDim text-base font-kanit !border-none !text-black"
                placeholder={"Choose Date"}
                format={"YYYY-MM-DD"}
              />
            </Form.Item>
          </div>
          <div>
            <Typography
              mb={4}
              type="p"
              fontFamily="font-kanit"
              fontWeight="font-light"
              fontSize={16}
            >
              Expiry Date
              <Typography
                type="span"
                fontFamily="font-kanit"
                fontWeight="font-light"
                textColor="error"
              >
                *
              </Typography>
            </Typography>
            <Form.Item
              name="expireAt"
              rules={[
                {
                  required: true,
                  message: "Please select an expired date",
                },
              ]}
            >
              <DatePicker
                className="min-w-[230px] h-[48px] rounded-lg bg-gray-border text-base font-kanit !border-none !text-black hover:bg-primaryDim"
                placeholder={"Choose Date"}
                format={"YYYY-MM-DD"}
              />
            </Form.Item>
          </div>
        </div>
        <DocumentModalFileUploader />
      </div>
    </>
  );
}
